//#region import
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ProjectContext } from '../../ProjectRequestFrom';
import { Convert, ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { BtnAdd, BtnCancel, BtnClearTable, BtnDraft, BtnEdit, BtnEditTable, BtnExportExcel, BtnSave, BtnSendRequest } from 'components/Button/ButtonAll';
import { APIStatusCode, EnumProjectActivityType, EnumProjectPlan, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled, Chip, Grid, Tooltip, Typography} from '@mui/material';
import { List as LINQ } from "linqts";
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { useLocation } from 'react-router';
import AccordionPanel from '../../components/AccordionPanel';
import SpendingPlanDuration from './SpendingPlanDuration';
import HeaderInput from 'components/Input/HeaderInput';
import moment from "moment";
import "../../StyleProject.css";
//#endregion

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const RequestSpendingPlan = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        nProjectSummary,
        setnProjectSummary,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        setnYearPlanID,
        setisChangePanel6,
        isChangePlan,
        setisChangePlan,
        nProjectVersionID,
        nLogChangeID,
        ObjCheckSubmitVersion,
        setObjCheckSubmitVersion,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [isError, setisError] = useState(false);        
    const [isBudgetBtn, setisBudgetBtn] = useState(false);
    const [arrDataYearID, setarrDataYearID] = useState([]);
    const [ObjDataAll, setObjDataAll] = useState(null);
    const [lstProjectSpendingPlanType, setlstProjectSpendingPlanType] = useState([]);
    const [_dStart, setdStart] = useState(null); //01/01/New + 1
    const [_dEnd, setdEnd] = useState(null); //31/12/New + 1    
    const [trigger, setTrigger] = useState(0);
    const [lstSummaryYear, setlstSummaryYear] = useState([]);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nYearID_SpendingPlan: null,
        } as any,
    });

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
        // if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    useEffect(() => {
        setisEditSecretary((isModeSecretary === true || nLogChangeID !== null) ? false : isPermission);
    }, [isModeSecretary, nLogChangeID]);

    useEffect(() => {
        if (isChangePanel12 === true && nProjectID !== 0) GetFormInitial();
    }, [isChangePanel12]); 

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormInitialProjectSpendingPlan, { nProjectID : nProjectID }, (result) => {
            setarrDataYearID(result.lstYearID);
            form.setValue("nYearID_SpendingPlan", result.lstYearID.length > 0 ? result.lstYearID[0].value : null);
            setdStart(new Date(result.nStartDate));
            setdEnd(new Date(result.nEndDate));
            setisChangePanel12(false);
            onClearField();
        });
    }

    useEffect(() => {
        if (nProjectID !== 0 || (isChangePanel9 === true || isChangePlan === true))
        {
            let nYear = form.getValues("nYearID_SpendingPlan");
            handleGetFormProjectID(nYear); 
            setnYearPlanID(Convert.StringToInt(nYear));
        }
        //arrDataYearID, (arrDataYearID.length > 0 && 
    }, [nProjectSummary, isChangePanel9, isChangePlan, nProjectID]);

    useEffect(() => {
        let nYear = Convert.StringToIntOrNull(form.getValues("nYearID_SpendingPlan"));
        if (nProjectID !== 0 && nYear !== null)
        {            
            handleGetFormProjectID(nYear); 
            setnYearPlanID(nYear ?? 0);
            onClearField();
        }
    }, [form.watch("nYearID_SpendingPlan")]);

    useEffect(() => {
        if (nProjectVersionID !== 0) {
            let nYear = form.getValues("nYearID_SpendingPlan");
            handleGetFormProjectID(nYear);
        }
    }, [nProjectVersionID]);

    const handleGetFormProjectID = (nYear) => {
        // DialogFn.BlockUI();
        let param = {
            nProjectID: nProjectID, 
            nYear: Convert.StringToInt(nYear), 
            nProjectSummary: nProjectSummary ?? 0,
            lstnYear: DefaultArrayEmpty((arrDataYearID || []).map(m=> Convert.StringToInt(m.value))),
            // lstnYear: new LINQ<any>(arrDataYearID).Select(s=> s.value).ToArray(),
            nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID),
        };
        // AxiosFn.Get(ApiProject.GetFormProjectID_SpendingPlan, param, (result) => {
        //     // DialogFn.UnBlockUI();
        //     setnProjectID(result.objResult.nProjectID);
        //     // setnStatusID(result.objResult.nStatusID);
        //     setisComplete(result.objResult.isComplete);
        //     // setnYear(result.objResult.nYear);
        //     setObjDataAll(result.objResult.ObjDataAll);
        //     setlstProjectSpendingPlanType(result.objResult.lstProjectSpendingPlanType);
        //     setisChangePanel9(false);
        //     setlstSummaryYear(result.objResult.lstSummaryYear);
        // });

        AxiosFn.Post(ApiProject.GetFormProjectID_SpendingPlan, param, (result) => {
            setnProjectID(result.objResult.nProjectID);
            setisComplete(result.objResult.isComplete);
            setObjDataAll(result.objResult.ObjDataAll);
            setlstProjectSpendingPlanType(result.objResult.lstProjectSpendingPlanType);
            setisChangePanel9(false);
            setisChangePlan(false);
            setlstSummaryYear(result.objResult.lstSummaryYear);
            setnBudget(new LINQ<any>(result.objResult.lstSummaryYear || []).FirstOrDefault(f=> f.nYear === Convert.StringToInt(nYear))?.nBudgetAll ?? null);
        });
    };

    //#region แผนการใช้จ่ายเงิน
    const [arrDuration, setarrDuration] = useState<any>([]);
    const [nProjectPlanID, setnProjectPlanID] = useState(null);
    const [nActivityTypeID, setnActivityTypeID] = useState(null); //EnumProjectActivityType
    const [sActivityName, setsActivityName] = useState(null);
    const [nBudgetAll, setnBudgetAll] = useState(null); 

    const formSpendingPlan = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const onAddDuration = (nActivityID) => {
        setTrigger(trigger + 1);

        let nMax = arrDuration.length > 0 ? Math.max(...arrDuration.map(o => o.nID)) : 0;
        nMax = nMax + 1;
        let obj = {
            nID: nMax,
            nActivityID: nActivityID,
            nActivityPlanID: 0,
            dStart: null,
            nDateStart: null,
            dEnd: null,
            nDateEnd: null,
            nMonthStart: null,
            nMonthEnd: null,
            // nWeight: null,
            nBudget: null,
        }
        let arrAdd = [...arrDuration, obj];
        setarrDuration(arrAdd);
    }

    const onDeleteDuration = (nID) => {
        let arrDel = arrDuration.filter(f => f.nID !== nID);
        setarrDuration(arrDel);
    }

    const onEditDuration = (ObjActivity, nActivityTypeID, ObjPlan, nModeID : EnumStatusMode) => {
        setTrigger(trigger + 1);

        setnActivityTypeID(nActivityTypeID);
        setnProjectPlanID(ObjActivity.nProjectPlanID);
        setsActivityName("กิจกรรมที่ " + ObjPlan.nOrder + "." + ObjActivity.nOrder + " " + ObjActivity.sActivity);
        setnBudgetAll(ObjActivity.nBudgetActivityAll);

        let lstDuration = [{
            nID: 1,
            nActivityID: ObjActivity.nActivityID,
            nActivityPlanID: 0,
            dStart: null,
            nDateStart: null,
            dEnd: null,
            nDateEnd: null,
            nMonthStart: null,
            nMonthEnd: null,
            // nWeight: null,
            nBudget: null,
        }]

        let arrDataSpendingPlan = [];
        (ObjActivity.lstSpendingPlanDate || []).forEach(iSpendingPlan => {
            arrDataSpendingPlan.push({
                nID: iSpendingPlan.nID,
                nActivityID: iSpendingPlan.nActivityID,
                nActivityPlanID: iSpendingPlan.nActivityPlanID,
                dStart: iSpendingPlan.dStart,
                nDateStart: iSpendingPlan.nDateStart,
                dEnd: iSpendingPlan.dEnd,
                nDateEnd: iSpendingPlan.nDateEnd,
                nMonthStart: iSpendingPlan.nMonthStart,
                nMonthEnd: iSpendingPlan.nMonthEnd,
                // nWeight: iSpendingPlan.nWeight,
                nBudget: iSpendingPlan.nBudget,
            });
            formSpendingPlan.setValue(`sStartMonth_SpendingPlan_${iSpendingPlan.nID}`, moment(iSpendingPlan.nDateStart).year(new Date().getFullYear())); //moment(iSpendingPlan.nDateStart).year(new Date().getFullYear()) //มีปัญหาที่ Date ไม่ขึ้นให้เลือกของปีที่เราต้องการเริ่ม มันมองแต่ปัจุบันเลยต้องใช้วิธีนี้ //moment(iSpendingPlan.nDateStart) ควรเป็นแบบนี้
            formSpendingPlan.setValue(`sEndMonth_SpendingPlan_${iSpendingPlan.nID}`, moment(iSpendingPlan.nDateEnd).year(new Date().getFullYear()));
            // formSpendingPlan.setValue(`nBudget_SpendingPlan_${iSpendingPlan.nID}`, ConvertNumberFormatterLocale(iSpendingPlan.nBudget, 2));
            formSpendingPlan.setValue(`nBudget_SpendingPlan_${iSpendingPlan.nID}`, iSpendingPlan.nBudget);
        });
        setarrDuration((ObjActivity.lstSpendingPlanDate || []).length > 0 ? [...arrDataSpendingPlan] : lstDuration);

        document.getElementById("myDivSpendingPlan").scrollIntoView({ behavior: "smooth" });
    }

    const onClearDuration = () => {
        Object.keys(formSpendingPlan.getValues()).forEach((key) => {
            formSpendingPlan.setValue(key, null);
            formSpendingPlan.clearErrors(key);
        });
    };

    const onClear = (ObjDataActivity, ObjDataSpendingPlan, ObjDataSpendingPlanType, nModeID : EnumStatusMode) => {
        setnProjectPlanID(null);
        setnActivityTypeID(null);
        setarrDuration([]);

        //#region UpDate
        ObjDataActivity.nM1 = null;
        ObjDataActivity.nM2 = null;
        ObjDataActivity.nM3 = null;
        ObjDataActivity.nM4 = null;
        ObjDataActivity.nM5 = null;
        ObjDataActivity.nM6 = null;
        ObjDataActivity.nM7 = null;
        ObjDataActivity.nM8 = null;
        ObjDataActivity.nM9 = null;
        ObjDataActivity.nM10 = null;
        ObjDataActivity.nM11 = null;
        ObjDataActivity.nM12 = null;
        ObjDataActivity.lstSpendingPlanDate = [];
        // // ObjDataActivity.nBudgetActivityAll = null;
        // ObjDataActivity.nBudgetActivity = null;
        // ObjDataSpendingPlanType.isSuccess = false;
        // ObjDataSpendingPlan.isSuccess = false;
        // ObjDataActivity.isUpDate = false;

        // nBudgetAll //ค่าเงินรวมทั้งกิจกรรม วงเงินตั้งต้น
        // nBudgetActivityAll //ค่าเงินรวมทั้งกิจกรรม
        // nBudgetYearAll //ค่าเงินรวมทั้งกิจกรรม ทุกปี   
        //เปลี่ยน เงื่อนไข ค่ารวมทั้งกิจกรรม ทุกปี 
        ObjDataActivity.nBudgetActivity = ObjDataActivity.nBudgetActivityYearAll !== null ? 0 : null; //null;
        ObjDataActivity.isUpDate = ObjDataActivity.nBudgetActivityYearAll !== null; //false; //ObjDataActivity.nBudgetActivityYearAll !== null ? true : false 
        // ObjDataSpendingPlanType.isSuccess = false;
        // ObjDataSpendingPlan.isSuccess = false;

        [...lstProjectSpendingPlanType].filter(w=> w.nActivityTypeID === ObjDataSpendingPlanType.nActivityTypeID).forEach(iType => {
            [...iType.lstProjectSpendingPlan].filter(w=> w.nActivityTypeID === iType.nActivityTypeID).forEach(iPlan => {
                // iPlan.nBudgetAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nBudgetActivityAll);  //ค่าเงินรวมทั้งกิจกรรม วงเงินตั้งต้น
                iPlan.nBudgetActivityAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nBudgetActivity);  //ค่าเงินรวมทั้งกิจกรรม

                // iPlan.nM1All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM1) || 0).reduce((a, b) => a + b, 0); //new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nM1); 
                // iPlan.nM2All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM2) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM3All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM3) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM4All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM4) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM5All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM5) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM6All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM6) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM7All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM7) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM8All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM8) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM9All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM9) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM10All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM10) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM11All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM11) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nM12All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM12) || 0).reduce((a, b) => a + b, 0);
                // iPlan.nQuarter1All = parseFloat((iPlan.nM1All ?? 0) + (iPlan.nM2All ?? 0) + (iPlan.nM3All ?? 0));
                // iPlan.nQuarter2All = parseFloat((iPlan.nM4All ?? 0) + (iPlan.nM5All ?? 0) + (iPlan.nM6All ?? 0));
                // iPlan.nQuarter3All = parseFloat((iPlan.nM7All ?? 0) + (iPlan.nM8All ?? 0) + (iPlan.nM9All ?? 0));
                // iPlan.nQuarter4All = parseFloat((iPlan.nM10All ?? 0) + (iPlan.nM11All ?? 0) + (iPlan.nM12All ?? 0));
                // let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s=> s.isUpDate === true).Count(); 
                // iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;

                iPlan.nM1All = iPlan.lstProjectPlanActivity.filter(f => f.nM1 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM1 !== null).Sum(s=> s.nM1) : null; 
                iPlan.nM2All = iPlan.lstProjectPlanActivity.filter(f => f.nM2 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM2 !== null).Sum(s=> s.nM2) : null;  
                iPlan.nM3All = iPlan.lstProjectPlanActivity.filter(f => f.nM3 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM3 !== null).Sum(s=> s.nM3) : null;  
                iPlan.nM4All = iPlan.lstProjectPlanActivity.filter(f => f.nM4 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM4 !== null).Sum(s=> s.nM4) : null;  
                iPlan.nM5All = iPlan.lstProjectPlanActivity.filter(f => f.nM5 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM5 !== null).Sum(s=> s.nM5) : null;  
                iPlan.nM6All = iPlan.lstProjectPlanActivity.filter(f => f.nM6 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM6 !== null).Sum(s=> s.nM6) : null;  
                iPlan.nM7All = iPlan.lstProjectPlanActivity.filter(f => f.nM7 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM7 !== null).Sum(s=> s.nM7) : null;  
                iPlan.nM8All = iPlan.lstProjectPlanActivity.filter(f => f.nM8 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM8 !== null).Sum(s=> s.nM8) : null;  
                iPlan.nM9All = iPlan.lstProjectPlanActivity.filter(f => f.nM9 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM9 !== null).Sum(s=> s.nM9) : null;  
                iPlan.nM10All = iPlan.lstProjectPlanActivity.filter(f => f.nM10 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM10 !== null).Sum(s=> s.nM10) : null;
                iPlan.nM11All = iPlan.lstProjectPlanActivity.filter(f => f.nM11 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM11 !== null).Sum(s=> s.nM11) : null;
                iPlan.nM12All = iPlan.lstProjectPlanActivity.filter(f => f.nM12 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM12 !== null).Sum(s=> s.nM12) : null;
                let nQ1 = null;
                let nQ2 = null;
                let nQ3 = null;
                let nQ4 = null;
                if (iPlan.nM1All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM1All;
                if (iPlan.nM2All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM2All;
                if (iPlan.nM3All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM3All;
                if (iPlan.nM4All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM4All;
                if (iPlan.nM5All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM5All;
                if (iPlan.nM6All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM6All;
                if (iPlan.nM7All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM7All;
                if (iPlan.nM8All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM8All;
                if (iPlan.nM9All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM9All;
                if (iPlan.nM10All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM10All;
                if (iPlan.nM11All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM11All;
                if (iPlan.nM12All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM12All;
                iPlan.nQuarter1All = nQ1;
                iPlan.nQuarter2All = nQ2;
                iPlan.nQuarter3All = nQ3;
                iPlan.nQuarter4All = nQ4;

                let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s=> s.isUpDate === true).Count(); 
                // iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;
                //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2
                // iPlan.isSuccess = nCountPlanActivity !== 0 ? true : false;
                //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2 แต่ๆ ต้องครบทุกอันที่มี งบประมาณมา
                iPlan.isSuccess = iPlan.nBudgetAll === 0 ? true : iPlan.nBudgetAll !== 0 && nCountPlanActivity !== 0 ? true : false;
            });
            let nCountPlan = new LINQ<any>(iType.lstProjectSpendingPlan).Where(s=> s.isSuccess === true).Count(); 
            // iType.isSuccess = (iType.lstProjectSpendingPlan || []).length === nCountPlan ? true : false;
            //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วยใช่ไหมค่ะ แค่ในส่วนของ 2/2
            // iType.isSuccess = nCountPlan !== 0 ? true : false;
            //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2 แต่ๆ ต้องครบทุกอันที่มี งบประมาณมา
            iType.isSuccess = (iType.lstProjectSpendingPlan || []).length === nCountPlan ? true : false;
        });
        //#endregion

        //#region Budget แบบทุกกิจกรรม
        let _nBudgetAll = 0;
        let _dataRowProject = [].concat(...lstProjectSpendingPlanType.map(m => m.lstProjectSpendingPlan))
        let clone = [..._dataRowProject];
        let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => f.nActivityID !== ObjDataActivity.nActivityID);
        _nBudgetAll = lstData.map(m => parseInt(m.nBudgetActivity) || 0).reduce((a, b) => a + b, 0); 
        setnBudget(_nBudgetAll); //รวมทั้งหมดโครงการ
        //#endregion
        
        onClearDuration();
    }

    const SetValueSum = (arr) => {
        let v = (arr || []).filter(f => f !== undefined && f !== null);
        if (v.length > 0) {
            let val = new LINQ<any>(v).Sum(s => s);
            return parseFloatCheckValue(val);
        } else {
            return null;
        }
    }

    const CallTableSpendingPlan = useCallback(() => {
        //#region arrSum nBudgetAll
        let arrSumnBudgetAll = [];
        let arrSumnQuarter1All = [];
        let arrSumnQuarter2All = [];
        let arrSumnQuarter3All = [];
        let arrSumnQuarter4All = [];
        //#endregion

        return (
            <TableContainer id='table-SpendingPlan' component={Paper}>
                <Table sx={{ minWidth: 500 }}>
                    <TableHead>
                        <TableRow>
                            {((isPermission && isModeSecretary !== true) || isEditSecretary === true) && <TableCell component="th" padding='none' style={{ minWidth: '95px', width: '95px' }} rowSpan={3}></TableCell>}
                            <TableCell component="th" padding='none' style={{ minWidth: '230px', width: '230px' }} rowSpan={3}>แผนงาน/กิจกรรม</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '150px', width: '150px' }} rowSpan={3}>งบประมาณ (บาท)</TableCell>
                            <TableCell component="th" padding='none' style={{ minWidth: '90px', width: '90px' }} colSpan={12}>การใช้จ่ายเงิน</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 1" + (form.getValues("nYearID_SpendingPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_SpendingPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 2" + (form.getValues("nYearID_SpendingPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_SpendingPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 3" + (form.getValues("nYearID_SpendingPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_SpendingPlan") + 543) : ""))}</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#fbfbfb', color: '#3e3e3e', minWidth: '20px', width: '20px' }} colSpan={3}>{ParseHtml("ไตรมาส 4" + (form.getValues("nYearID_SpendingPlan") ? "<br/> ปี บัญชี " + Convert.StringToInt(form.getValues("nYearID_SpendingPlan") + 543) : ""))}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ม.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.พ.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>มี.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>เม.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>พ.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>มิ.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ส.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ก.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ต.ค.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>พ.ย.</TableCell>
                            <TableCell component="th" padding='none' style={{ backgroundColor: '#073d7b', minWidth: '10px', width: '10px' }}>ธ.ค.</TableCell>
                        </TableRow>
                    </TableHead>
                    {lstProjectSpendingPlanType.length > 0 ?
                        <TableBody>
                            {lstProjectSpendingPlanType.map((iSpendingPlanType, index) => {
                                return (
                                    <>
                                        {iSpendingPlanType?.nActivityTypeID === EnumProjectActivityType.Manage ? 
                                                <TableRow key={`sID_SpendingPlan_Manage`}>
                                                    <TableCell className='bg-color3' colSpan={(!isPermission || isEditSecretary === false) ? 14 : 15} align="left">{"งบ" + (iSpendingPlanType?.sActivityType ?? "บริหารโครงการ")}</TableCell>
                                                </TableRow>
                                            : 
                                            iSpendingPlanType?.nActivityTypeID === EnumProjectActivityType.Operate ? 
                                                <TableRow key={`sID_SpendingPlan_Operate`}>
                                                    <TableCell className='bg-color3' colSpan={(!isPermission || isEditSecretary === false) ? 14 : 15} align="left">{"งบ" + (iSpendingPlanType?.sActivityType ?? "ดำเนินโครงการ")}</TableCell>
                                                </TableRow>
                                            : <></>
                                        }
                                        {(iSpendingPlanType?.lstProjectSpendingPlan || []).filter(f=> f.nActivityTypeID === iSpendingPlanType.nActivityTypeID).map((iSpendingPlan) => {
                                            //#region arrSum nBudgetAll
                                            // if (parseFloatCheckValue(iSpendingPlan.nBudgetAll)) arrSumnBudgetAll.push(iSpendingPlan.nBudgetAll);
                                            if (iSpendingPlan.nBudgetAll !== null) arrSumnBudgetAll.push(iSpendingPlan.nBudgetAll);
                                            if (iSpendingPlan.nQuarter1All !== null) arrSumnQuarter1All.push(iSpendingPlan.nQuarter1All);
                                            if (iSpendingPlan.nQuarter2All !== null) arrSumnQuarter2All.push(iSpendingPlan.nQuarter2All);
                                            if (iSpendingPlan.nQuarter3All !== null) arrSumnQuarter3All.push(iSpendingPlan.nQuarter3All);
                                            if (iSpendingPlan.nQuarter4All !== null) arrSumnQuarter4All.push(iSpendingPlan.nQuarter4All);
                                            //#endregion

                                            return (
                                                <>
                                                    <TableRow key={`sID_SpendingPlan_Plan_${iSpendingPlan.nProjectPlanID}`}>
                                                        <TableCell className='bg-color' colSpan={(!isPermission || isEditSecretary === false) ? 14 : 15} align="left">{"แผนงานที่ " + iSpendingPlan.nOrder + ". " + iSpendingPlan.sPlan}</TableCell>
                                                    </TableRow>
                                                    {(iSpendingPlan?.lstProjectPlanActivity || []).filter(f=> f.nProjectPlanID === iSpendingPlan.nProjectPlanID).map((iActivity) => {
                                                        return (
                                                            <TableRow key={`sID_SpendingPlan_Activity_${iActivity.nActivityID}`} sx={{ height: '50px',}}>
                                                                {!iActivity.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                                    <TableCell align="center">    
                                                                        {(iActivity.nBudgetActivityAll !== 0 || (iActivity.nBudgetActivityAll === 0 && (iActivity.lstSpendingPlanDate || []).length > 0)) &&                                                                
                                                                            <Grid item xs={12} md={12} container spacing={1} key={`Btn_SpendingPlan_${iActivity.nActivityID}`}>
                                                                                {iActivity.nBudgetActivityAll !== 0 &&
                                                                                    <Grid item>
                                                                                        <BtnEditTable
                                                                                            key={"btnEdit_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                            id={"btnEdit_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                            onClick={() => { onClearField(); onEditDuration(iActivity, iSpendingPlanType?.nActivityTypeID, iSpendingPlan, EnumStatusMode.Edit)} }
                                                                                            IsDisabled={!isPermission || isEditSecretary === false}
                                                                                            IsCircleWithOutText={true}
                                                                                        />
                                                                                    </Grid>
                                                                                }
                                                                                <Grid item>
                                                                                    <BtnClearTable
                                                                                        key={"btnDelete_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                        id={"btnDelete_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                        onClick={() => onClear(iActivity, iSpendingPlan, iSpendingPlanType, EnumStatusMode.Clear)}
                                                                                        IsDisabled={!isPermission || isEditSecretary === false}
                                                                                        IsCircleWithOutText={true}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        }
                                                                            {/* :
                                                                            <BtnViewTable
                                                                                key={"btnPreview_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                id={"btnPreview_SpendingPlan_Activity_" + iActivity.nActivityID}
                                                                                onClick={() => { onClearField(); onEditDuration(iActivity, iSpendingPlanType?.nActivityTypeID, EnumStatusMode.View)} }
                                                                                // IsDisabled={!isPermission || isEditSecretary === false}
                                                                                IsCircleWithOutText={true}
                                                                            /> */}
                                                                    </TableCell>
                                                                }
                                                                <TableCell align="left">
                                                                    <Grid item xs={12} md={12}>
                                                                        <Typography variant='body2'>{ParseHtml("กิจกรรมที่ " + iSpendingPlan.nOrder + "." + iActivity.nOrder + " " + iActivity.sActivity)}</Typography>
                                                                    </Grid>
                                                                </TableCell>                                             
                                                                <TableCell align="center">
                                                                    <Grid item xs={12} md={12}>
                                                                        <Typography variant='body2'>{formatNumber(iActivity.nBudgetActivityAll, 2)}</Typography>
                                                                    </Grid>
                                                                </TableCell>
            
                                                                {/* ไตรมาส 1 */}
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM1), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM1 !== null  ? '#9f6110' : ''), color: (iActivity.nM1 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM2), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM2 !== null  ? '#9f6110' : ''), color: (iActivity.nM2 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM3), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM3 !== null  ? '#9f6110' : ''), color: (iActivity.nM3 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
            
                                                                {/* ไตรมาส 2 */}
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM4), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM4 !== null  ? '#9f6110' : ''), color: (iActivity.nM4 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM5), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM5 !== null  ? '#9f6110' : ''), color: (iActivity.nM5 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM6), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM6 !== null  ? '#9f6110' : ''), color: (iActivity.nM6 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
            
                                                                {/* ไตรมาส 3 */}
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM7), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM7 !== null  ? '#9f6110' : ''), color: (iActivity.nM7 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM8), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM8 !== null  ? '#9f6110' : ''), color: (iActivity.nM8 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM9), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM9 !== null  ? '#9f6110' : ''), color: (iActivity.nM9 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
            
                                                                {/* ไตรมาส 4 */}
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM10), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM10 !== null  ? '#9f6110' : ''), color: (iActivity.nM10 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM11), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM11 !== null  ? '#9f6110' : ''), color: (iActivity.nM11 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                                <Tooltip title={formatNumber(parseFloatCheckValue(iActivity.nM12), 2)} placement="top" arrow>
                                                                    <TableCell align="center" style={{backgroundColor: (iActivity.nM12 !== null  ? '#9f6110' : ''), color: (iActivity.nM12 !== null  ? 'white' : '')}}>{""}</TableCell>
                                                                </Tooltip>
                                                            </TableRow>
                                                        )
                                                    })}  
                                                </>
                                            )})   
                                        }                                   
                                    </>
                                )
                            })}
                            {arrSumnBudgetAll.length > 0 &&
                                <TableRow key={`sID_SpendingPlan_SumAll`}>
                                    <TableCell className='bg-color1' colSpan={(!isPermission || isEditSecretary === false) ? 1 : 2} align="center" style={{ backgroundColor: '#3787ff', color: '#f7f7f7',}}>รวมวงเงินรายไตรมาสและประจำปี</TableCell>
                                    <TableCell className='bg-color1' align="center" style={{ backgroundColor: '#f7f7f7', color: '#3e3e3e',}}>{GetSumBudgetAll(arrSumnBudgetAll)}</TableCell>
                                    <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter1All), 2)}</TableCell>
                                    <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter2All), 2)}</TableCell>
                                    <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter3All), 2)}</TableCell>
                                    <TableCell className='bg-color1' colSpan={3} align="center">{formatNumber(SetValueSum(arrSumnQuarter4All), 2)}</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                        :
                        <TableRow key={"r-no-data_SpendingPlan"}>
                            <TableCell align="center" colSpan={(!isPermission || isEditSecretary === false) ? 14 : 15}>ไม่พบข้อมูล</TableCell>
                        </TableRow>
                    }
                </Table>
            </TableContainer>
        );
    }, [lstProjectSpendingPlanType, isEditSecretary]);

    const [nBudget, setnBudget] = useState(null); 
    const GetSumBudgetAll = (arrSumnBudgetAll) => {
        let nSumBudgetAll = SetValueSum(arrSumnBudgetAll);
        // setnBudget(nSumBudgetAll);
        return formatNumber(nSumBudgetAll, 2);
    }

    useEffect(() => {
        if (nBudget > nProjectSummary) {
            setisError(true);
            setisBudgetBtn(false);  
            // DialogFn.Warning("ผลรวมจำนวนเงินต่อเดือนของโครงการเกิน " + formatNumber(nProjectSummary, 2));
        } else {
            setisError(false);
            if (nBudget === nProjectSummary && arrDataYearID.length === 1) { //ถ้ามีปีเดียวต้องเท่ากับ งบประมาณทั้งหมด ถึงกดปุ่มพร้อมส่งได้
                setisBudgetBtn(true);
            } 
            else if (nBudget < nProjectSummary && arrDataYearID.length === 1) {
                setisBudgetBtn(false);  
            } else {
                if (arrDataYearID.length > 1) { //ถ้ามีหลายปีจะต้องเอาทุกปีมาพวกกันก่อน
                    let nYear = form.getValues("nYearID_SpendingPlan") ? Convert.StringToInt(form.getValues("nYearID_SpendingPlan")) : 0;
                    let nBudgetAllYear = new LINQ<any>(lstSummaryYear).Where(w=> w.nYear !== nYear).Sum(s=> s.nBudgetAll);
                    let _nBudgetAllYear = nBudget + nBudgetAllYear;  
                    setisBudgetBtn(_nBudgetAllYear === nProjectSummary ? true : false);

                    ////จะต้องยังไม่ดัน ว่ารายปี ยังไม่ถึง nProjectSummary ห้ามบันทึก จะต้อง กดบันทึกได้ และ ค่อยเอาทุกปีมาเช็ค
                    // setisBudgetBtn(true);
                } else {
                    setisBudgetBtn(nBudget === nProjectSummary ? true : false);
                }
            }
        }
    }, [nBudget, nProjectSummary]); //}, [nBudget]);

    const onAddSpendingPlan = () => {
        let _lstDuration = arrDuration ?? [];
        let nYear = form.getValues("nYearID_SpendingPlan") ? Convert.StringToInt(form.getValues("nYearID_SpendingPlan")) : 0;
        let nActivityID = new LINQ<any>(_lstDuration).FirstOrDefault()?.nActivityID ?? 0;
        let _nBudgetActivityAll = 0;

        //#region Budget แบบทุกกิจกรรม
        let _nBudgetAll = 0;
        let _dataRowProject = [].concat(...lstProjectSpendingPlanType.map(m => m.lstProjectSpendingPlan))
        let clone = [..._dataRowProject];
        let lstData = [].concat(...clone.map(m => m.lstProjectPlanActivity)).filter(f => f.nActivityID !== nActivityID);
        _nBudgetAll = lstData.map(m => parseInt(m.nBudgetActivity) || 0).reduce((a, b) => a + b, 0);           
        //#endregion
        
        _lstDuration.forEach(iDuration => {
            let dDateStart = moment(formSpendingPlan.getValues(`sStartMonth_SpendingPlan_${iDuration.nID}`));
            let dDateEnd = moment(formSpendingPlan.getValues(`sEndMonth_SpendingPlan_${iDuration.nID}`));
            let nUnixTimeStart = dDateStart.isValid ? ConvertDateToUnixOrNull(dDateStart.startOf('month').year(nYear)) : null;
            let nUnixTimeEnd = dDateEnd.isValid ? ConvertDateToUnixOrNull(dDateEnd.endOf('month').year(nYear)) : null;
            // let sDateStart = Convert.DateTimeToString(dDateStart.format("YYYY-MM-DD"), "MMMM YYYY", "th");
            // let sDateEnd = Convert.DateTimeToString(dDateEnd.format("YYYY-MM-DD"), "MMMM YYYY", "th");
            let nMonthStart = parseInt(dDateStart.format("M"));
            let nMonthEnd = parseInt(dDateEnd.format("M"));
            let nBudget = parseFloatCheckValue(formSpendingPlan.getValues(`nBudget_SpendingPlan_${iDuration.nID}`));                
            iDuration.dStart = dDateStart;
            iDuration.nDateStart = nUnixTimeStart;
            iDuration.dEnd = dDateEnd;
            iDuration.nDateEnd = nUnixTimeEnd;
            iDuration.nMonthStart = nMonthStart;
            iDuration.nMonthEnd = nMonthEnd;
            iDuration.nBudget = nBudget;

            //#region ค่าแต่ล่ะช่วงเดือน
            // let nDiff = moment(formSpendingPlan.getValues(`sEndMonth_SpendingPlan_${iDuration.nID}`)).diff(moment(formSpendingPlan.getValues(`sStartMonth_SpendingPlan_${iDuration.nID}`)), "month");
            let nDiff = nMonthEnd - nMonthStart;
            let _nBudget = 0;
            if (!isNaN(nDiff) && nBudget) {
                _nBudget = nBudget * (nDiff + 1);
            }
            _nBudgetActivityAll += _nBudget;
            //#endregion
        });

        //#region ตรวจสอบ งบประมาณของทุกปี ตามรายกิจกรรม ว่าเกินค่า งบประมาณทั้งหมดของ กิจกรรมนั้นหรือไม่
        _nBudgetAll = _nBudgetAll + _nBudgetActivityAll; //รวมทั้งหมดโครงการ
        setnBudget(_nBudgetAll);
        let _lstSummaryYear = lstSummaryYear.filter(f=> f.nYear !== nYear);
        let sWarning = null;
        // let _nBudgetAll = new LINQ<any>(_lstDuration).Sum(s=> s.nBudget);
        if (_lstSummaryYear.length > 0 && arrDataYearID.length > 1)
        {
            let _lstActivityBudget = [].concat(..._lstSummaryYear.map(m => m.lstActivityBudget)).filter(f => f.nActivityID === nActivityID);
            let nBudgetAllYear = _lstActivityBudget.map(m => parseInt(m.nBudgetActivityAll) || 0).reduce((a, b) => a + b, 0);  

            // let nBudgetAllYear = new LINQ<any>(_lstSummaryYear).Select(s => s.lstActivityBudget).Sum(s=> s.nBudgetAll);
            let _nBudgetAllYear = _nBudgetActivityAll + nBudgetAllYear;
            if (_nBudgetActivityAll > nBudgetAll) // nBudgetAll << nBudgetActivityAll (คือมากกว่ารายกิจกรรม)
            {
                sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเงินเกิน งบประมาณทั้งหมดของกิจกรรม.";
            }
            else if (_nBudgetAllYear > nBudgetAll) //ทุกปีรวมกัน และมากกว่ารายกิจกรรม
            {
                sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเงินในทุกปีเกิน งบประมาณทั้งหมดของกิจกรรม.";
            }
        } 
        else if (_nBudgetActivityAll > nBudgetAll) {
            sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเงินเกิน งบประมาณทั้งหมดของกิจกรรม.";
        }
        else if (_nBudgetAll > nProjectSummary) {
            sWarning = "ไม่สามารถเพิ่มข้อมูลได้ กรุณาตรวจสอบความถูกต้องของข้อมูล งบประมาณเกิน ผลรวมวงเงินโครงการ.";
        }
        if (sWarning !== null) return DialogFn.Warning(sWarning);
        //#endregion
        
        (lstProjectSpendingPlanType || []).filter(w=> w.nActivityTypeID === nActivityTypeID).forEach(iType => {
            (iType.lstProjectSpendingPlan || []).filter(w=> w.nProjectPlanID === nProjectPlanID).forEach(iPlan => {
                    (iPlan.lstProjectPlanActivity || []).filter(w=> w.nActivityID === nActivityID).forEach(iActivity => {
                        iActivity.lstSpendingPlanDate = _lstDuration;
                        iActivity.nM1 = _lstDuration.find(f => f.nMonthStart <= 1 && f.nMonthEnd >= 1 )?.nBudget ?? null;
                        iActivity.nM2 = _lstDuration.find(f => f.nMonthStart <= 2 && f.nMonthEnd >= 2 )?.nBudget ?? null;
                        iActivity.nM3 = _lstDuration.find(f => f.nMonthStart <= 3 && f.nMonthEnd >= 3 )?.nBudget ?? null;
                        iActivity.nM4 = _lstDuration.find(f => f.nMonthStart <= 4 && f.nMonthEnd >= 4 )?.nBudget ?? null;
                        iActivity.nM5 = _lstDuration.find(f => f.nMonthStart <= 5 && f.nMonthEnd >= 5 )?.nBudget ?? null;
                        iActivity.nM6 = _lstDuration.find(f => f.nMonthStart <= 6 && f.nMonthEnd >= 6 )?.nBudget ?? null;
                        iActivity.nM7 = _lstDuration.find(f => f.nMonthStart <= 7 && f.nMonthEnd >= 7 )?.nBudget ?? null;
                        iActivity.nM8 = _lstDuration.find(f => f.nMonthStart <= 8 && f.nMonthEnd >= 8 )?.nBudget ?? null;
                        iActivity.nM9 = _lstDuration.find(f => f.nMonthStart <= 9 && f.nMonthEnd >= 9 )?.nBudget ?? null;
                        iActivity.nM10 = _lstDuration.find(f => f.nMonthStart <= 10 && f.nMonthEnd >= 10 )?.nBudget ?? null;
                        iActivity.nM11 = _lstDuration.find(f => f.nMonthStart <= 11 && f.nMonthEnd >= 11 )?.nBudget ?? null;
                        iActivity.nM12 = _lstDuration.find(f => f.nMonthStart <= 12 && f.nMonthEnd >= 12 )?.nBudget ?? null;
                        let arrSumnBudgetAll = [];
                        if (iActivity.nM1 !== null) arrSumnBudgetAll.push(iActivity.nM1); //parseFloatCheckValue(iActivity.nM1)
                        if (iActivity.nM2 !== null) arrSumnBudgetAll.push(iActivity.nM2);
                        if (iActivity.nM3 !== null) arrSumnBudgetAll.push(iActivity.nM3);
                        if (iActivity.nM4 !== null) arrSumnBudgetAll.push(iActivity.nM4);
                        if (iActivity.nM5 !== null) arrSumnBudgetAll.push(iActivity.nM5);
                        if (iActivity.nM6 !== null) arrSumnBudgetAll.push(iActivity.nM6);
                        if (iActivity.nM7 !== null) arrSumnBudgetAll.push(iActivity.nM7);
                        if (iActivity.nM8 !== null) arrSumnBudgetAll.push(iActivity.nM8);
                        if (iActivity.nM9 !== null) arrSumnBudgetAll.push(iActivity.nM9);
                        if (iActivity.nM10 !== null) arrSumnBudgetAll.push(iActivity.nM10);
                        if (iActivity.nM11 !== null) arrSumnBudgetAll.push(iActivity.nM11);
                        if (iActivity.nM12 !== null) arrSumnBudgetAll.push(iActivity.nM12);

                        // iActivity.nBudgetActivity = SetValueSum(arrSumnBudgetAll); //parseFloatCheckValue(SetValueSum(arrSumnBudgetAll)); //new LINQ<any>(_lstDuration).Sum(s=> s.nBudget);
                        // // iActivity.nBudgetActivityAll = iActivity.nBudgetActivityAll; //ค่าเงินที่เพิ่มมาจาก Panel 9 ของแต่ล่ะกิจกรรม
                        // iActivity.isUpDate = (_lstDuration || []).length > 0 ? true : false;

                        // nBudgetAll //ค่าเงินรวมทั้งกิจกรรม วงเงินตั้งต้น
                        // nBudgetActivityAll //ค่าเงินรวมทั้งกิจกรรม
                        // nBudgetYearAll //ค่าเงินรวมทั้งกิจกรรม ทุกปี       
                        iActivity.nBudgetActivity = SetValueSum(arrSumnBudgetAll) ?? (iActivity.nBudgetActivityYearAll !== null ? 0 : null); //ค่าเงินรวมทั้งกิจกรรม > ค่าเงินรวมของทุกเดือน
                        iActivity.isUpDate = (iActivity.nBudgetActivityYearAll !== null || (_lstDuration || []).length > 0) ? true : false;
                    });
                    // iPlan.nBudgetAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nBudgetActivityAll); //ค่าเงินรวมทั้งกิจกรรม วงเงินตั้งต้น
                    iPlan.nBudgetActivityAll = new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s => s.nBudgetActivity); //ค่าเงินรวมทั้งกิจกรรม
                    // iPlan.nBudgetYearAll //ค่าเงินรวมทั้งกิจกรรม ทุกปี

                    // iPlan.nM1All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM1) || 0).reduce((a, b) => a + b, 0); //new LINQ<any>(iPlan.lstProjectPlanActivity).Sum(s=> s.nM1); 
                    // iPlan.nM2All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM2) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM3All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM3) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM4All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM4) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM5All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM5) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM6All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM6) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM7All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM7) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM8All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM8) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM9All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM9) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM10All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM10) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM11All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM11) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nM12All = [...iPlan.lstProjectPlanActivity].map(m => parseFloat(m.nM12) || 0).reduce((a, b) => a + b, 0);
                    // iPlan.nQuarter1All = parseFloat((iPlan.nM1All ?? 0) + (iPlan.nM2All ?? 0) + (iPlan.nM3All ?? 0));
                    // iPlan.nQuarter2All = parseFloat((iPlan.nM4All ?? 0) + (iPlan.nM5All ?? 0) + (iPlan.nM6All ?? 0));
                    // iPlan.nQuarter3All = parseFloat((iPlan.nM7All ?? 0) + (iPlan.nM8All ?? 0) + (iPlan.nM9All ?? 0));
                    // iPlan.nQuarter4All = parseFloat((iPlan.nM10All ?? 0) + (iPlan.nM11All ?? 0) + (iPlan.nM12All ?? 0));

                    iPlan.nM1All = iPlan.lstProjectPlanActivity.filter(f => f.nM1 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM1 !== null).Sum(s=> s.nM1) : null; 
                    iPlan.nM2All = iPlan.lstProjectPlanActivity.filter(f => f.nM2 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM2 !== null).Sum(s=> s.nM2) : null;  
                    iPlan.nM3All = iPlan.lstProjectPlanActivity.filter(f => f.nM3 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM3 !== null).Sum(s=> s.nM3) : null;  
                    iPlan.nM4All = iPlan.lstProjectPlanActivity.filter(f => f.nM4 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM4 !== null).Sum(s=> s.nM4) : null;  
                    iPlan.nM5All = iPlan.lstProjectPlanActivity.filter(f => f.nM5 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM5 !== null).Sum(s=> s.nM5) : null;  
                    iPlan.nM6All = iPlan.lstProjectPlanActivity.filter(f => f.nM6 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM6 !== null).Sum(s=> s.nM6) : null;  
                    iPlan.nM7All = iPlan.lstProjectPlanActivity.filter(f => f.nM7 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM7 !== null).Sum(s=> s.nM7) : null;  
                    iPlan.nM8All = iPlan.lstProjectPlanActivity.filter(f => f.nM8 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM8 !== null).Sum(s=> s.nM8) : null;  
                    iPlan.nM9All = iPlan.lstProjectPlanActivity.filter(f => f.nM9 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM9 !== null).Sum(s=> s.nM9) : null;  
                    iPlan.nM10All = iPlan.lstProjectPlanActivity.filter(f => f.nM10 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM10 !== null).Sum(s=> s.nM10) : null;
                    iPlan.nM11All = iPlan.lstProjectPlanActivity.filter(f => f.nM11 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM11 !== null).Sum(s=> s.nM11) : null;
                    iPlan.nM12All = iPlan.lstProjectPlanActivity.filter(f => f.nM12 !== null).length > 0 ? new LINQ<any>(iPlan.lstProjectPlanActivity).Where(f => f.nM12 !== null).Sum(s=> s.nM12) : null;
                    let nQ1 = null;
                    let nQ2 = null;
                    let nQ3 = null;
                    let nQ4 = null;
                    if (iPlan.nM1All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM1All;
                    if (iPlan.nM2All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM2All;
                    if (iPlan.nM3All !== null) nQ1 = (nQ1 ?? 0) + iPlan.nM3All;
                    if (iPlan.nM4All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM4All;
                    if (iPlan.nM5All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM5All;
                    if (iPlan.nM6All !== null) nQ2 = (nQ2 ?? 0) + iPlan.nM6All;
                    if (iPlan.nM7All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM7All;
                    if (iPlan.nM8All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM8All;
                    if (iPlan.nM9All !== null) nQ3 = (nQ3 ?? 0) + iPlan.nM9All;
                    if (iPlan.nM10All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM10All;
                    if (iPlan.nM11All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM11All;
                    if (iPlan.nM12All !== null) nQ4 = (nQ4 ?? 0) + iPlan.nM12All;
                    iPlan.nQuarter1All = nQ1;
                    iPlan.nQuarter2All = nQ2;
                    iPlan.nQuarter3All = nQ3;
                    iPlan.nQuarter4All = nQ4;

                    let nCountPlanActivity = new LINQ<any>(iPlan.lstProjectPlanActivity).Where(s=> s.isUpDate === true).Count(); 
                    // iPlan.isSuccess = (iPlan.lstProjectPlanActivity || []).length === nCountPlanActivity ? true : false;
                    //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2
                    // iPlan.isSuccess = nCountPlanActivity !== 0 ? true : false;
                    //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2 แต่ๆ ต้องครบทุกอันที่มี งบประมาณมา
                    iPlan.isSuccess = iPlan.nBudgetAll === 0 ? true : iPlan.nBudgetAll !== 0 && nCountPlanActivity !== 0 ? true : false;
            });
            let nCountPlan = new LINQ<any>(iType.lstProjectSpendingPlan).Where(s=> s.isSuccess === true).Count(); 
            // iType.isSuccess = (iType.lstProjectSpendingPlan || []).length === nCountPlan ? true : false;
            //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วยใช่ไหมค่ะ แค่ในส่วนของ 2/2
            // iType.isSuccess = nCountPlan !== 0 ? true : false;
            //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2 แต่ๆ ต้องครบทุกอันที่มี งบประมาณมา
            iType.isSuccess = (iType.lstProjectSpendingPlan || []).length === nCountPlan ? true : false;
        });
        onClearField();
    };

    const onClearField = () => {
        setnProjectPlanID(null);
        setnActivityTypeID(null);
        setsActivityName(null);
        setnBudgetAll(null);
        setarrDuration([]);
        Object.keys(formSpendingPlan.getValues()).forEach((key) => {
            formSpendingPlan.setValue(key, null);
            formSpendingPlan.clearErrors(key);
        });
        onClearDuration();
    };
    //#endregion

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        // let nSpendingPlanAll = lstProjectSpendingPlanType.length;
        // let nSpendingPlan = lstProjectSpendingPlanType.filter(f=> f.isSuccess === true).length;
        // if (nSpendingPlanAll !== nSpendingPlan && nModeID === EnumSaveModeProject.Submit) {
        //     return DialogFn.Warning("กรุณาเพิ่มข้อมูล แผนงาน/กิจกรรม ให้ครบถ้วน");
        // }
        //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วยใช่ไหมค่ะ แค่ในส่วนของ 2/2
        // let nSpendingPlan = lstProjectSpendingPlanType.filter(f=> f.isSuccess === true).length;
        // if (nSpendingPlan === 0 && nModeID === EnumSaveModeProject.Submit) {
        //     return DialogFn.Warning("กรุณาเพิ่มข้อมูล แผนงาน/กิจกรรม ต้องอย่างน้อย 1 กิจกรรม.");
        // }
        //ไม่ครบทุกกิจกรรม และไม่ต้องครบทุกแผน ด้วย แค่ในส่วนของ 2/2 แต่ๆ ต้องครบทุกอันที่มี งบประมาณมา
        let nSpendingPlanAll = lstProjectSpendingPlanType.length;
        let nSpendingPlan = lstProjectSpendingPlanType.filter(f=> f.isSuccess === true).length;
        if (nSpendingPlanAll !== nSpendingPlan && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลงบประมาณ ให้ครบทุกกิจกรรมที่มีงบประมาณ.");
        }

        let ObjData = form.getValues();
        let nYear = Convert.StringToInt(ObjData.nYearID_SpendingPlan);
        let isComplete = null;
        if (nStatusID !== EnumProjectStatusID.nStatusID_0)
        {
            //กรณีที่เลย ส่งนำเสนอมาและแก้ไข และข้อมูลยังไม่ถูกต้อง ให้ไปอัพเดตให้เป็น บันทึกร่าง และถ้า กดอีกที ข้อมูลถูกให้เป้น บันทึกพร้อมส่ง <<< isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง"
            //จะต้องเอาทุกปีมาเช็ค ว่าเท่ากับ nProjectSummary งบประมาณทั้งหมด ไหม ต้องเท่ากับ งบประมาณทั้งหมด nProjectSummary เท่านั้น รวมกันทุกปี
            let nBudgetAllYear = new LINQ<any>(lstSummaryYear).Where(w=> w.nYear !== nYear).Sum(s=> s.nBudgetAll);
            let _nBudgetAllYear = nBudget + nBudgetAllYear;
            isComplete = _nBudgetAllYear === nProjectSummary; // isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
        }

        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPlanID: EnumProjectPlan.SpendingPlan,
            isFastTrack: isFastTrack,

            nYear: nYear,
            ObjDataAll: ObjDataAll,
            lstProjectSpendingPlanType: lstProjectSpendingPlanType,

            sLocation: location.pathname,
            isComplete: isComplete, // isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent)
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectRequestSpendingPlan, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        // setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        setisComplete(isComplete ?? (nModeID === EnumSaveModeProject.Draft ? false : true)); //หลัง ส่งนำเสนอ //isComplete > False = บันทึกร่าง | True = บันทึกพร้อมส่ง | Null = ไม่ต้องไปบันทึกเพิ่ม
                        setisChangePanel6(true);
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };
    
    const CheckSubmitProjectChangeStatus = () => { //ไว้เช็คตอนที่มีการเปลี่ยนแปลก Panel 7 | Panel 9 จะมีผลต่อนี้
        let nSpendingPlanAll = lstProjectSpendingPlanType.length;
        let nSpendingPlan = lstProjectSpendingPlanType.filter(f=> f.isSuccess === true).length;

        let isWarning = false;
        let sWarning = "";
        if (nSpendingPlanAll !== nSpendingPlan){
            isWarning = true;
            sWarning += "- กท 2/2 (แผนการใช้จ่ายเงิน) : กรุณาเพิ่มข้อมูลงบประมาณ ให้ครบทุกกิจกรรมที่มีงบประมาณ. <br/>";
        }

        //จะต้องเอาทุกปีมาเช็ค ว่าเท่ากับ nProjectSummary งบประมาณทั้งหมด ไหม ต้องเท่ากับ งบประมาณทั้งหมด nProjectSummary เท่านั้น รวมกันทุกปี
        let nYear = form.getValues("nYearID_SpendingPlan") ? Convert.StringToInt(form.getValues("nYearID_SpendingPlan")) : 0;
        let nBudgetAllYear = new LINQ<any>(lstSummaryYear).Where(w=> w.nYear !== nYear).Sum(s=> s.nBudgetAll);
        let _nBudgetAllYear = nBudget + nBudgetAllYear;

        if (_nBudgetAllYear > nProjectSummary) {
            isWarning = true;
            sWarning += "- กท 2/2 (แผนการใช้จ่ายเงิน) : กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเงินในทุกปีเกิน งบประมาณทั้งหมดของกิจกรรม.<br/>";
        }
        else if (_nBudgetAllYear < nProjectSummary) {
            isWarning = true;
            sWarning += "- กท 2/2 (แผนการใช้จ่ายเงิน) : กรุณาตรวจสอบความถูกต้องของข้อมูล มีจำนวนเงินในทุกปีไม่เท่ากับ งบประมาณทั้งหมดของกิจกรรม.<br/>";
        }

        setObjCheckSubmitVersion({
            isPanel9: ObjCheckSubmitVersion?.isPanel9,
            sWarningPanel9: ObjCheckSubmitVersion?.sWarningPanel9,
            isWorkPlan: ObjCheckSubmitVersion?.isWorkPlan,
            sWarningWorkPlan: ObjCheckSubmitVersion?.sWarningWorkPlan,
            isSpendingPlan: true,
            // sWarningSpendingPlan: (nSpendingPlanAll !== nSpendingPlan ? "- กท 2/2 (แผนการใช้จ่ายเงิน) : กรุณาเพิ่มข้อมูลงบประมาณ ให้ครบทุกกิจกรรมที่มีงบประมาณ. <br/>" : null),
            sWarningSpendingPlan: (isWarning ? sWarning : null),
        }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    }

    const handleExportExcel = () => {
        let nYear = Convert.StringToIntOrNull(form.getValues("nYearID_SpendingPlan"));
        //Plan 2/1 Work Plan && Plan 2/2 Spending Plan
        let sFileName = `แผนการใช้จ่ายเงินประจำปี_${nYear + 543}.xlsx`;

        let ObjData = {
            nProjectID: nProjectID,
            nYear: nYear,
            nProjectSummary: nProjectSummary ?? 0,
            lstnYear: DefaultArrayEmpty((arrDataYearID || []).map(m=> Convert.StringToInt(m.value))),
            nProjectVersionID: (nProjectVersionID === 0 ? null : nProjectVersionID),

            sProjectName: ObjDataAll?.sProjectName ?? " - ",
            sUnitOwnerName: ObjDataAll?.sUnitOwnerName ?? " - ",
            // sAreaName: ObjDataAll?.sAreaName.replaceAll("<br/>", "\n") ?? " - ",
            sAreaName: ObjDataAll?.sAreaName.replaceAll("<br/>", ", ") ?? " - ",
            sPeriod: ObjDataAll?.sPeriod ?? " - ",
            sMoney: ObjDataAll?.nMoney != null ? (formatNumber(ObjDataAll?.nMoney, 2) ?? " - ") + " บาท (" + (ObjDataAll?.sMoneyThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")" : " - ",
        };

        AxiosFn.DowloadFileBlob(ApiProject.ExportExcelSpendingPlan, ObjData, sFileName, (result) => {}, (err) => {}, DialogFn.BlockUI(), DialogFn.UnBlockUI());
    }

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">แผนการใช้จ่ายเงินประจำปี</Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            {nProjectID !== 0 ?
                                <SelectItem
                                    id="nYearID_SpendingPlan"
                                    name="nYearID_SpendingPlan"
                                    options={arrDataYearID}
                                    label={""}
                                    required={true}
                                    IsClearable={true}
                                    // onChange={handleGetFormProjectID}
                                />
                                :
                                <Typography variant='body1'>{" - "}</Typography>
                            }
                        </Grid>
                        {nProjectID !== 0 &&
                            <Grid item xs={12} md={2} justifyContent={"center"} sx={{ display: "flex" }}>
                                <BtnExportExcel id={"expReportSpendingPlan"} tooltiptxt='Export to Excel File' onClick={() => { handleExportExcel() }} />
                            </Grid>
                        }
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ชื่องาน/โครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sProjectName ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">เจ้าของโครงการ/ผู้มีสิทธิ์</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sUnitOwnerName ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">พื้นที่ดำเนินงาน</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ParseHtml(ObjDataAll?.sAreaName ?? " - ")}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ระยะเวลาดำเนินโครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Typography variant='body1'>{ObjDataAll?.sPeriod ?? " - "}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">วงเงิน</Typography>
                        </Grid>
                        {ObjDataAll?.nMoney != null ?
                            <Grid item xs={12} md={9} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1'>{formatNumber(ObjDataAll?.nMoney, 2)?? " - "}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">บาท</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1'>{"(" + (ObjDataAll?.sMoneyThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")"}</Typography>
                                </Grid>
                            </Grid>
                            :
                            <Grid item xs={12} md={9}>
                                <Typography variant='body1'>{" - "}</Typography>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                    <AccordionPanel
                        header={"การใช้จ่ายเงิน"}
                        isExpanded={false} 
                        // SubHeader={}
                        color="white"
                        bgColor="rgb(102,151,245)"
                        background="#5598fc"
                        expandIconColor="white"
                        borderColor="1px solid #5598fc"
                        borderRadius="18px !important"
                        boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                        boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                        SubHeaderStatus={
                            (isComplete !== null &&
                                <Chip
                                    size="small"
                                    label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                                    style={{
                                        color: "white",
                                        backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                                        fontSize: "14px"
                                    }}
                                />     
                            )      
                        }
                    >
                        <Grid id='myDivSpendingPlan' item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
                            <FormProvider {...formSpendingPlan}>
                                {(nProjectPlanID !== null && nActivityTypeID !== null ) &&
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <HeaderInput text={"ชื่อกิจกรรม :  " + sActivityName} />
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="flex-start" alignItems="flex-start" style={{ paddingBottom: '1%', }}>
                                            <Grid item xs={12} md={2}>
                                                <HeaderInput text={"ระยะเวลาปฎิบัติงาน"} />
                                            </Grid>
                                            <Grid item xs={12} md={10}>
                                                <SpendingPlanDuration
                                                    nYear={Convert.StringToInt(form.watch("nYearID_SpendingPlan"))}
                                                    formDuration={formSpendingPlan}
                                                    onAddDuration={onAddDuration}
                                                    onDeleteDuration={onDeleteDuration}
                                                    arrDuration={arrDuration}
                                                    dataRowProject={lstProjectSpendingPlanType}
                                                    // isPermission={isPermission}
                                                    isPermission={((isPermission && isModeSecretary !== true) ? isPermission : isEditSecretary ?? false)}
                                                    // nBudgetAll={nProjectSummary} //จำนวนเงินทั้งโครงการ
                                                    nBudgetAll={nBudgetAll} //จำนวนเงินทั้งกิจกรรม
                                                    dStart={_dStart}
                                                    dEnd={_dEnd}
                                                    trigger={trigger}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                                (arrDuration.filter((f) => f.dStart === null).length > 0 ?
                                                    <Grid item>
                                                        <BtnAdd id={"btnAdd_SpendingPlan"} txt={"เพิ่มข้อมูล"} onClick={formSpendingPlan.handleSubmit((e) => onAddSpendingPlan(),(err) => console.log("err", err))} />                                                                                                    
                                                    </Grid>
                                                    :
                                                    <Grid item>
                                                        <BtnSave id={"btnSave_SpendingPlan"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formSpendingPlan.handleSubmit((e) => onAddSpendingPlan(),(err) => console.log("err", err))} />
                                                    </Grid>
                                                )
                                            }
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_SpendingPlan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { onClearField(); }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                    <CallTableSpendingPlan />
                                </Grid>
                            </FormProvider>
                        </Grid>
                    </AccordionPanel>
                </Grid>
                {nProjectID === 0 || (nStatusID === EnumProjectStatusID.nStatusID_11 && nLogChangeID === null) ?
                    <></>
                :
                    (isPermission === true &&
                        (isModeSecretary !== true ?
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                    <Grid item>
                                        <BtnDraft id={"btnDraft_SpendingPlan"} IsDisabled={isError} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                    </Grid>
                                }
                                <Grid item>
                                    {/* IsDisabled={isError || !isWeightBtn} ปิดไว้เพราะจะเกิดกรณีที่ เลขาแก้ไข เขาต้องบันทึกทีล่ะปีได้ และการบันทึกตรงนี้ถ้ากรณีที่ มากกว่า 1 ปี จะต้องมองด้วยว่าครบ วงเงินตั้งต้น ถ้าเลยการทำงานของ ส่งนำเสนอมาแล้ว จะไม่เช็คและอัพเดต ให้เป็นบันทึกร่าง เท่านั้น */}
                                    <BtnSendRequest id={"btnSend_SpendingPlan"} IsDisabled={(nStatusID === EnumProjectStatusID.nStatusID_0 ? (isError || !isBudgetBtn) : isError)} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit) }} />
                                </Grid>
                            </Grid>
                        : 
                            (isModeSecretary === true ?
                                <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                    {isEditSecretary === false ?
                                        <Grid item>
                                            <BtnEdit id={"btnEdit_SpendingPlan"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivSpendingPlan").scrollIntoView({ behavior: "smooth" });}} />
                                        </Grid>
                                        :
                                        <>
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_SpendingPlan"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); onClearField(); handleGetFormProjectID(form.watch("nYearID_SpendingPlan")); }} />
                                            </Grid>
                                            <Grid item>
                                                {/* IsDisabled={isError || !isWeightBtn} ปิดไว้เพราะจะเกิดกรณีที่ เลขาแก้ไข เขาต้องบันทึกทีล่ะปีได้ และการบันทึกตรงนี้ถ้ากรณีที่ มากกว่า 1 ปี จะต้องมองด้วยว่าครบ วงเงินตั้งต้น ถ้าเลยการทำงานของ ส่งนำเสนอมาแล้ว จะไม่เช็คและอัพเดต ให้เป็นบันทึกร่าง เท่านั้น */}
                                                <BtnSendRequest id={"btnSend_SpendingPlan"} IsDisabled={isError} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                            </Grid>
                                        </>
                                    }   
                                </Grid>
                                : <></>
                            )
                        )
                    )
                }
                <Grid item style={{ display: 'none'}}>
                    <BtnSendRequest id={"btnCheck_SpendingPlan_ChangeStatus"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { CheckSubmitProjectChangeStatus(); }} />
                </Grid>
            </FormProvider>
        </Grid>
    )
}
export default RequestSpendingPlan;
